export default {
    init() {    
        $('.woocommerce form .form-row input').on('focus', (e) => {
            let label = e.target.id;

            $('.woocommerce form .form-row label').removeClass('active');
        
            $('label[for="' + label + '"]').addClass('active');
        });
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/woocommerceCheckout.js